import axiosRat from '../axios-rat';
import { getFakeToken, handleApiError } from '../common/util';
import { IDmsInfo, IVersionData } from '../models/dms.model';

export const getDmsVersion = async (dbId: number, companyUid: string) => {
  try {
    const url = `/api/utility/applicationinfo/v1/dmsversion`;
    const token = getFakeToken(dbId, companyUid);
    let params = {} as any;
    let headers = {
      authorization: `bearer ${token}`
    } as any;

    const response = await axiosRat.get<IVersionData>(`${url}`, {
      params,
      headers
    });
    return response.data;
  } catch (err: any) {
    return handleApiError(getDmsVersion.name, err);
  }
};

export const getDmsInfo = async (dbId: number, companyUid: string, useCache: boolean) => {
  try {
    const url = `/api/utility/applicationinfo/v1/cloudtest`;
    const token = getFakeToken(dbId, companyUid, useCache);
    let params = {} as any;
    let headers = {
      authorization: `bearer ${token}`
    } as any;

    const response = await axiosRat.get<IDmsInfo>(`${url}`, {
      params,
      headers
    });
    return response.data;
  } catch (err: any) {
    return handleApiError(getDmsInfo.name, err);
  }
};